import React, { useState, useEffect } from 'react';

import {
  getServices,
  postService,
  editService,
  deleteService,
} from '../../../api/services/servicesApi';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminServiceCard from '../../../components/admin/cards/AdminServiceCard/AdminServiceCard';
import ServiceModal from '../../../components/admin/modals/ServiceModal/ServiceModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminServices.css';

const AdminServices = () => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  //Service Admin Page
  const getAllServices = async () => {
    const allServices = await getServices();
    setServices(allServices);
  };

  useEffect(() => {
    getAllServices();
  }, []);

  const onAddClickHandler = () => {
    setSelectedService({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (service) => {
    setSelectedService(service);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (service) => {
    setSelectedService(service);
    setIsDeleteModalOpen(true);

    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedService(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedService(null);
  };

  const handleSubmit = async (formData, imagesToDelete) => {
    try {
      if (editModalMode === 'edit') {
        await editService(selectedService._id, formData);
        alert('Service updated successfully!');
      } else {
        await postService(formData);
        alert('Service created successfully!');
      }

      await getAllServices();
      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Submit failed:', error);
    }
  };

  const onConfirmDelete = async () => {
    await deleteService(selectedService._id);
    await getAllServices();
    onDeleteModalClose();
    alert(`Deleted! ${selectedService.title} deleted successfully!`);
  };

  return (
    <div className='services-page-container'>
      <div className='services__page'>
        <div className='admin-services-title-add-service-container'>
          <h1 className='admin-services-title'>Services</h1>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={onAddClickHandler}
          >
            Add Service
          </ContentChangeButton>
        </div>
        <div className='services__layout'>
          {services.map((s) => (
            <AdminServiceCard
              key={s._id}
              service={s}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
            />
          ))}
        </div>
      </div>
      {isEditModalOpen && (
        <ServiceModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          service={selectedService}
          mode={editModalMode}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={selectedService?.title}
          deleteItemMsg={'This will also delete all associated prices.'}
        />
      )}
    </div>
  );
};

export default AdminServices;
